import React from "react";

// Dashboard
const UserDashboard = React.lazy(() => import("../../Users/UserDashboard"));

// Contracts
const UserContracts = React.lazy(() => import("../../Users/UserContracts"));
const UserContractDetails = React.lazy(() => import("../../Users/UserContractDetails"));

// Reports
const UserInstallmentsReport = React.lazy(
  () => import("../../Users/Reports/UserInstallmentsReport"),
);
const UserPaymentsReport = React.lazy(() => import("../../Users/Reports/UserPaymentsReport"));

// Profile
const Profile = React.lazy(() => import("../../Users/Profile/Profile"));
const Password = React.lazy(() => import("../../Users/Profile/Password"));

// Users Management
const Users = React.lazy(() => import("../../Users/Users/Users"));
const UserForm = React.lazy(() => import("../../Users/Users/UserForm"));

export const userRoutes = [
  // Customer Portal
  {
    path: "/user/dashboard",
    Component: UserDashboard,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/contracts",
    Component: UserContracts,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/contracts/contract-detail",
    Component: UserContractDetails,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/reports/installments",
    Component: UserInstallmentsReport,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/reports/payments",
    Component: UserPaymentsReport,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/profile/user-info",
    Component: Profile,
    rolename: "CustomerPortal",
  },
  {
    path: "/user/profile/password",
    Component: Password,
    rolename: "CustomerPortal",
  },

  // Users Management (Settings)
  {
    path: "/settings/users",
    Component: Users,
    rolename: "Settings_Users",
  },
  {
    path: "/settings/users/add",
    Component: UserForm,
    rolename: "Settings_Users",
  },
];
